module.exports = __webpack_public_path__ + "img/car_orange.34ac67d7.svg";